import React from "react"
import { Button, Modal } from "react-bootstrap"
import "./ReviewSubmitNag.css"

interface Props {
    updateReview: Function
}

function ReviewSubmitNag(props: Props) {
    return (
        <div className="ReviewSubmitNag">
            <Modal id="review-submit-nag-modal"
                show={true}
                backdrop="static"
                keyboard={true}
                centered={true}
            >
                <Modal.Header>
                    <div className="ReviewSubmitNagModalHeader">
                        <p>Submit this review?</p>
                    </div>
                </Modal.Header>
                <Modal.Footer>
                    <div className="ReviewSubmitNagModalFooter">
                        <Button variant="secondary" onClick={() => props.updateReview()}>Just save for now</Button>
                        <Button onClick={() => props.updateReview(true)}>Yes</Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default ReviewSubmitNag